import { useEffect, useState } from "react";
import { api, formatDateTime } from "@/lib/api";
import { Card } from "@/components/ui/card";

export default function Logs() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/logs").then(({ data }) => setItems(data)); }, []);

  return (
    <div className="space-y-6" data-testid="logs-page">
      <div>
        <div className="text-[11px] uppercase tracking-[0.2em] text-zinc-500 font-mono">Auditoria</div>
        <h1 className="font-display text-4xl font-bold tracking-tight mt-1">Logs</h1>
        <p className="text-sm text-zinc-500 mt-1">Trilha de auditoria de todas as ações do tenant.</p>
      </div>

      <Card className="rounded-sm border border-zinc-200 shadow-none overflow-x-auto">
        <table className="tbl" data-testid="logs-table">
          <thead>
            <tr>
              <th>Quando</th><th>Ação</th><th>Ator</th><th>Detalhes</th>
            </tr>
          </thead>
          <tbody>
            {items.length === 0 && <tr><td colSpan={4} className="text-center py-12 text-sm text-zinc-500">Sem registros.</td></tr>}
            {items.map((l) => (
              <tr key={l.id}>
                <td className="font-mono text-xs whitespace-nowrap">{formatDateTime(l.created_at)}</td>
                <td className="font-mono text-xs">{l.action}</td>
                <td className="font-mono text-xs">{l.actor?.slice(0, 8) || "-"}</td>
                <td><code className="text-[11px] text-zinc-600 break-all">{JSON.stringify(l.details)}</code></td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
